import FileUploadIcon from '@mui/icons-material/FileUpload'
import { OpenDialogButton } from '@/components/ConsoleDialog/handlers'
import {
  DGEImportLicensesForm,
  DGEImportLicensesFormProps
} from '@/components/forms/ImportLicenses/streaming/ImportLicensesForm.dge'
import { DDELicenseForm, DDELicenseFormProps } from '@/components/forms/LicenseForm/LicenseForm.dde'
import {
  DGELicenseForm,
  DGELicenseFormProps
} from '@/components/forms/LicenseForm/streaming/LicenseForm.dge'
import { PlatformDependent } from '@/components/PlatformDependent'

const DGEFormButton = (props: DGELicenseFormProps) => (
  <PlatformDependent streaming>
    <OpenDialogButton label="Add License">
      <DGELicenseForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)

const DDELicenseFormButton = (props: DDELicenseFormProps) => (
  <PlatformDependent dde>
    <OpenDialogButton label="Add License">
      <DDELicenseForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)

export const LicenseFormButton = {
  DDE: DDELicenseFormButton,
  DGE: DGEFormButton
}

const DGEImportFormButton = (props: DGEImportLicensesFormProps) => (
  <PlatformDependent streaming>
    <OpenDialogButton
      label="Import Licenses"
      ButtonProps={{ variant: 'outlined', startIcon: <FileUploadIcon /> }}
    >
      <DGEImportLicensesForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)

export const ImportLicensesFormButton = {
  DGE: DGEImportFormButton
}
